import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import {
  Button,
} from '@resy/ui-kitchen';
import { handleMktAnalytics } from '../../AmexMarketingUtils/AmexUtils';
import { CTA_EVENT_NAME } from '../../AmexMarketingUtils/constants';
import './DeltaWifiCitySelector.scss';

class DeltaWifiCitySelector extends React.Component {
  state = {
    selectedCityCode: '',
    loading: false,
  }

  cityButton = (item) => {
    const { selectedCityCode, loading } = this.state;
    const { fetchBookNowForAgnostic, analyticsEvent } = this.props;

    return (
      <Button
        variant="no-style"
        type="button"
        aria-current={selectedCityCode === item.code}
        {...loading === true ? { disabled: true } : ''}
        className={cx('DeltaWifiCitySelector__citypanel__button', {
          selectedcity: (selectedCityCode === item.code),
        })}
        onClick={() => {
          fetchBookNowForAgnostic(item);
          this.setState({ selectedCityCode: item.code });
          const extraParams = {
            action_name: 'City Pill Click',
            ...(item.name && { item_name: item.name }),
          };
          handleMktAnalytics(analyticsEvent, CTA_EVENT_NAME, extraParams);
        }}
        key={item.code}
      >
        {item.name}
      </Button>

    );
  };

  cityButtonPanel = () => {
    const { citySelectorConfig } = this.props;
    const { cityselector_cities: cities } = citySelectorConfig?.agnostic;

    return cities.map((item) => this.cityButton(item));
  };

  render() {
    const { selectedCityCode } = this.state;
    const { citySelectorConfig } = this.props;
    const { title, description, click_text: clickText } = citySelectorConfig?.agnostic;
    return (
      <section className="DeltaWifiCitySelector__section" id="cityselector">
        <article className="DeltaWifiCitySelector__wrapper">
          <div className="container">
            <h2 className="DeltaWifiCitySelector__title">{title}</h2>
            <div className="DeltaWifiCitySelector__content">
              <p>{description}</p>
              <div className="DeltaWifiCitySelector__citywrapper">
                <nav
                  className="DeltaWifiCitySelector__citypanel"
                  aria-label="Participating restaurants"
                >
                  {this.cityButtonPanel()}
                </nav>
              </div>
              {!selectedCityCode && <p className="clickText">{clickText}</p>}
            </div>
          </div>
        </article>
      </section>
    );
  }
}

DeltaWifiCitySelector.propTypes = {
  fetchBookNowForAgnostic: PropTypes.func.isRequired,
  citySelectorConfig: PropTypes.shape({
    agnostic: PropTypes.shape({
      cityselector_cities: PropTypes.arrayOf(PropTypes.object),
    }),
  }).isRequired,
  analyticsEvent: PropTypes.func.isRequired,
};

export default DeltaWifiCitySelector;
